export enum AppName {
    PROJECTS = 'Projects',
    DASHBOARD = 'Dashboard',
    SPECIES_TRENDS = 'Species trends',
    HABITAT_TRENDS = 'Habitat trends',
    STATISTICAL_COMPARISON = 'Statistical comparison',
    TAXONOMIC_COMPOSITION = 'Taxonomic composition',
    COMMUNITY_COMPARISON = 'Community Comparison',
    SAMPLE_METRICS_TABLE = 'Sample metrics table',
    SAMPLE_COMPARISON = 'Sample comparison',
    MAP = 'Map',
    PORTFOLIO_SITE_EXPLORER = 'Portfolio site explorer',
    UPGRADE_SUBSCRIPTION = 'Upgrade Subscription',
    PORTFOLIO_SUMMARY = 'Portfolio Summary',
    PORTFOLIO_SPECIES_RISK = 'Portfolio Species Risk',
    SITE_SUMMARY = 'Site Summary',
    SITE_FILES = 'Site Files',
}

export const DefaultInviteeName = {
    firstName: 'Invited',
    lastName: 'User',
};
